import { NetFetch } from '../Net/NetFetch';
import { UnauthorizedError } from './Error/UnauthorizedError';
import { StatusCodes } from './Status/StatusCodes';
/**
 * Admin CRUD for the per-organisation external-tour-source config.
 * All endpoints are admin-gated server-side; non-admins receive 403.
 */
export class ExternalTourSource {
    static async getList() {
        var _a;
        const result = await NetFetch.postData('/json/external-tour-source/list', {});
        if (result && result.statusCode) {
            switch (result.statusCode) {
                case StatusCodes.OK:
                    return (_a = (result.list)) !== null && _a !== void 0 ? _a : [];
                case StatusCodes.UNAUTHORIZED:
                    throw new UnauthorizedError();
            }
        }
        return [];
    }
    /**
     * Create (id=0) or update one source. Returns true when the
     * server reports OK.
     */
    static async save(entry) {
        const result = await NetFetch.postData('/json/external-tour-source/save', entry);
        if (result && result.statusCode) {
            switch (result.statusCode) {
                case StatusCodes.OK:
                    return true;
                case StatusCodes.UNAUTHORIZED:
                    throw new UnauthorizedError();
            }
        }
        return false;
    }
    static async delete(req) {
        const result = await NetFetch.postData('/json/external-tour-source/delete', req);
        if (result && result.statusCode) {
            switch (result.statusCode) {
                case StatusCodes.OK:
                    return true;
                case StatusCodes.UNAUTHORIZED:
                    throw new UnauthorizedError();
            }
        }
        return false;
    }
}
